import { ROUTES } from 'utils/constants';

/** True for staff InStoreQR routes and the public customer menu. */
export function isInstoreqrPath(pathname: string): boolean {
  const path = pathname.split('?')[0]?.replace(/\/$/, '') || '/';
  const root = ROUTES.INSTOREQR.ROOT;
  return path === root || path.startsWith(`${root}/`);
}
